<one-isp-manual-offline-banner></one-isp-manual-offline-banner>
@if (showLogbackHeader()) {
  <one-isp-inspection-logback-header></one-isp-inspection-logback-header>
}
